import { createContext, useContext, type ReactNode } from "react"

const PortalContainerContext = createContext<HTMLElement | null>(null)

export function PortalContainerProvider({
  container,
  children,
}: {
  container: HTMLElement | null
  children: ReactNode
}) {
  // For embeds we need dialogs/portals to stay inside the host's shadow DOM.
  // Radix defaults to rendering into document.body, which breaks style encapsulation,
  // so we allow callers to pass the embed host element as the portal container.
  return (
    <PortalContainerContext.Provider value={container}>
      {children}
    </PortalContainerContext.Provider>
  )
}

export function usePortalContainer() {
  return useContext(PortalContainerContext)
}
